var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoDetail = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_details",
    d: "M446.711,477.914a2.968,2.968,0,0,1,.088-.579q.051-.228.154-.6l.9-3.369c.01-.04.019-.079.026-.117a.579.579,0,0,0,.011-.11c0-.2-.063-.325-.19-.374a2.509,2.509,0,0,0-.7-.1v-.4q.424-.03,1.234-.121t1.146-.157l.645-.125-1.165,4.279q-.145.549-.2.762a3.961,3.961,0,0,0-.132.7c0,.107.024.177.073.209a.3.3,0,0,0,.161.048c.151,0,.339-.13.564-.388a5.888,5.888,0,0,0,.593-.813l.33.212a10.226,10.226,0,0,1-1.118,1.453,1.944,1.944,0,0,1-1.362.615,1.174,1.174,0,0,1-.737-.253A.918.918,0,0,1,446.711,477.914Zm2.9-9.39a1,1,0,0,1,1,1,.982.982,0,0,1-.293.714.965.965,0,0,1-.71.3,1.024,1.024,0,0,1-1.014-1.014.961.961,0,0,1,.3-.71A.982.982,0,0,1,449.611,468.524Zm-1.3-3.746a9,9,0,1,0,9,9A9,9,0,0,0,448.311,464.778Zm0,16.364a7.364,7.364,0,1,1,7.364-7.364A7.364,7.364,0,0,1,448.311,481.142Z",
    transform: "translate(-439.311 -464.778)",
    fill: "#999"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoDetail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_detail.6d09abee24266e456096c6de0a8d3442.svg";